import * as t from 'io-ts'
import { pipe } from 'fp-ts/lib/function'
import { Maybe } from '@mxt/zio/codec'
import { POApi } from '@pulseops/common'
import { Task, ZIO } from '@mxt/zio'
import { Duration } from '@mxt/zio/date'
export namespace ACViewMetricListService {
  export const ACViewMetricListRequest = t.type({
    start: t.number,
    size: t.number,
    orders: t.array(t.string),
    sort: Maybe(t.string),
    groupId: Maybe(t.string),
    metricCode: Maybe(t.string),
    visible: t.boolean,
    isPaginate: t.boolean
  })

  export const ACViewMetricResponse = t.type({
    id: t.string,
    metricCode: t.string,
    groupId: t.string,
    groupMetrics: t.string,
    metricName: t.string,
    value: t.string,
    method: t.string,
    description: t.string,
    priority: t.string,
    operator: t.string,
    operatorValue: t.string,
    type: t.string,
    ragThreshold: t.string,
    multiplier: t.string,
    visible: t.boolean
  })

  export const ACSavedMetricListResponse = t.type({
    id: t.string,
    requestId: t.number,
    metricCode: t.string,
    status: t.string,
    type: Maybe(t.string),
    oldMetric: t.type({
      id: t.string,
      metricCode: t.string,
      groupId: t.string,
      groupMetrics: t.string,
      metricName: t.string,
      value: t.string,
      method: t.string,
      description: t.string,
      priority: t.string,
      operator: t.string,
      operatorValue: t.string,
      type: t.string,
      ragThreshold: t.string,
      multiplier: t.string,
      visible: t.boolean
    }),
    newOperator: t.string,
    newOperatorValue: t.string,
    newRagThreshold: t.string,
    newMultiplier: t.string,
    approvedDate: Maybe(t.string),
    approver: Maybe(t.string),
    createdAt: t.string,
    createdBy: t.string,
    updatedAt: t.string,
    updatedBy: t.string,
  })

  export const ACMetricGroupInfo = t.type({
    groupId: t.string,
    groupMetrics: t.string
  })

  export type ACViewMetricListRequest = t.OutputOf<typeof ACViewMetricListRequest>
  export type ACViewMetricResponse = t.OutputOf<typeof ACViewMetricResponse>
  export type ACMetricGroupInfo = t.OutputOf<typeof ACMetricGroupInfo>

  export const getACViewMetricList = (body: ACViewMetricListRequest) => pipe(
    POApi.internalPost(`internal/administration-rest/bsc/search-metrics`)(t.type({
      total: t.number,
      start: t.number,
      size: t.number,
      data: t.array(ACViewMetricResponse)
    }))(body),
    ZIO.map((response) => {
      return response
    })
  )

  export const getACMetricGroupList: Task<ACMetricGroupInfo[]> = pipe(
    POApi.internalGet(`internal/administration-rest/bsc/group-metrics`)(t.type({
      data: t.array(ACMetricGroupInfo)
    })),
    ZIO.cached(Duration.minutes(15)),
    ZIO.map((response) => {
      return response.data
    })
  )

  export const saveEditedMetricList = (bodyData: ACViewMetricResponse[]) => pipe(
    POApi.internalPost(`internal/administration-rest/bsc/request-approve`)(t.type({
      data: t.array(ACSavedMetricListResponse),
      errors: Maybe(t.array(t.type({
        code: t.string,
        message: t.string
      })))
    }))(
      bodyData
    ),
    ZIO.map((response) => {
      return response
    })
  )
}